import { SavedGroupConfigurations } from "./types";

export const saveGroupConfigurationsGloballyGenric = (
  currentStateGroupConfigData: SavedGroupConfigurations,
  savedGroupConfigurations: any,
  setGlobalData: any,
) => {
  // Clone the existing configurations
  const updatedConfigurations = [...(savedGroupConfigurations || [])];

  // Find the index of the configuration to update
  const configIndex = updatedConfigurations.findIndex(
    (config) => config.id === currentStateGroupConfigData?.id,
  );

  if (configIndex !== -1) {
    // Update the existing configuration
    updatedConfigurations[configIndex] = { ...currentStateGroupConfigData };
  } else {
    console.error(`Configuration with id ${currentStateGroupConfigData?.id} not found.`);
  }

  // Update the global state
  setGlobalData({ savedGroupConfigurations: updatedConfigurations });
};
